export const REQUEST_LOAD = 'APP/REQUEST_LOAD';
export const LOAD_ERROR = 'APP/ERROR';
export const LOADED = 'APP/LOADED';
export const REDIRECT_LOGIN = 'APP/REDIRECT_LOGIN';

// User
export const SET_USER = 'APP/SET_USER';
